export default __webpack_public_path__ + "static/media/contact.20d47dff.jpg";